import _ 					from "lodash";

import Service 				from "./../../Libs/Service";
import { Project }			from "./Project";
import { Asset }			from "./Asset";
import { Localization }		from "./Localization";
import { Server }			from "./Server";
import { Version }			from "./Version";
import { Screen } 			from "./Screen";
import { DisplayObject } 	from "./DisplayObject";
import { Animation } 		from "./Animation";
import { Publisher } 		from "./Publisher";


import SetupSettings		from "../settings/settings";

let Settings = new Service({

	Name: "Settings",

	Events: {

	},

	Actions: {

		//Первоначальная загрузка всех изменённых настроек всех версий одного проекта
		"VersionsSettings": function(projectsVersionSettings) {

			_.each(projectsVersionSettings, projectPlayableSettings => {

				_.each(projectPlayableSettings, (versionSettings, versionId) => {

					this.SettingsByVersionByCodename[versionId] = {};

					_.each(versionSettings, versionSetting => {

						this.setVersionSetting(versionSetting);

					});

					if (versionId === Version.SelectedVersion?.id) Broadcast.call("Selected Version Settings Loaded", [versionSettings]);

				});

			});

			Broadcast.call("Version Settings Loaded", [projectsVersionSettings]);

		},

		//Первоначальная загрузка всех original настроек (из json файлов игры) всех версий одного проекта
		"VersionsSettingsOriginal": function(projectsVersionSettingsOriginal) {

			_.each(projectsVersionSettingsOriginal, projectVersionSettingsOriginal => {

				_.each(projectVersionSettingsOriginal, (versionSettingsOriginal, versionId) => {

					this.SettingsOriginalByVersionByCodename[versionId] = {};

					_.each(versionSettingsOriginal, versionSetting => {

						this.setVersionSettingOriginal(versionSetting);

					});

					if (versionId === Version.SelectedVersion?.id) Broadcast.call("Selected Version Settings Original Loaded", [versionSettingsOriginal]);

				});

			});

			Broadcast.call("Version Settings Original Loaded", [projectsVersionSettingsOriginal]);

		},

		//Изменение одной настройки
		"VersionSetting": function(data) {

			let versionId = data.versionId;
			let settingCodename = data.settingCodename;
			let versionSetting = data.versionSetting;

			if (versionSetting) {

				this.setVersionSetting(versionSetting);

				if (versionId === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Setting Changed`, [settingCodename, versionSetting.value]);
					Broadcast.call(`Selected Version Setting Changed:${settingCodename}`, [versionSetting.value]);

				}

			} else {

				delete this.SettingsByVersionByCodename[versionId][settingCodename];

				if (versionId === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Setting Changed`, [settingCodename, this.getSettingValue(settingCodename)]);
					Broadcast.call(`Selected Version Setting Changed:${settingCodename}`, [this.getSettingValue(settingCodename)]);

				}

			}

			let settingProps = this.getSettingProps(settingCodename);
			if (settingProps?.["options"]?.["refreshOnChange"] && versionId === Version.SelectedVersion?.id) Broadcast.call("Refresh Iframe");

		},

		"AmazonS3UploadProgress": function(data, full_data) {

			Broadcast.call("Amazon S3 upload Progress", [full_data]);

		},

		"MraidioUploadProgress": function(data, full_data) {

			Broadcast.call("Mraidio Upload Progress", [full_data]);

		},

		"SkyKidsUploadProgress": function(data, full_data) {

			Broadcast.call("Sky Kids upload Progress", [full_data]);

		}

	},

	init() {

		//Настройки всех версий всех проектов из БД (отличия от значения по умолчанию)
		this.SettingsByVersionByCodename = {};
		//Настройки по умолчанию из json файлов
		this.SettingsOriginalByVersionByCodename = {};

		//Таймауты на сохранение изменившихся настроек
		this.saveSettingValueTimeouts = {};

		this.TagTemplateProduction =
			'<!DOCTYPE html>' +
			'<html lang="en">' +
			'	<head>' +
			'		<meta http-equiv="content-type" content="text/html; charset=utf-8">' +
			'		<meta charset="UTF-8">' +
			'	</head>' +
			'	<body>' +
			'		<script>' +
			'			"settings-place"' +
			'		</script>' +
			'		"scripts-place"' +
			'		<script src="loader-url"></script>' +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-dashboard-integration-script.js"></script>` +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-release-integration-script.js"></script>` +
			'		"scripts-place-2"' +
			'	</body>' +
			'</html>';

		this.TagTemplateDevelopment =
			'<!DOCTYPE html>' +
			'<html lang="en">' +
			'	<head>' +
			'		<meta http-equiv="content-type" content="text/html; charset=utf-8">' +
			'		<meta charset="UTF-8">' +
			'	</head>' +
			'	<body>' +
			'		<script>' +
			'			"settings-place"' +
			'		</script>' +
			'		<script>Settings["game-code-url"] = false;</script>' +
			'		"scripts-place"' +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-dashboard-integration-script.js"></script>` +
			`		<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-release-integration-script.js"></script>` +
			'		"scripts-place-2"' +
			'	</body>' +
			'</html>';

		window.addEventListener("message", e => {

			if (e.data) {

				if (!e.data.log) console.info(`%c<<< SEND FROM IFRAME <<`, 'color: #b400d8', e.data);

				if (e.data["setSettingFromGame"]) {

					// Если запрещено переписывать базовую версию настроек и сейчас выбрана базовая версия
					if (!e.data["setSettingFromGame"]["replaceBase"] && Version.SelectedVersion.Tags.base) return

					this.setSettingValue(e.data["setSettingFromGame"]["settingCodename"], e.data["setSettingFromGame"]["value"]);

				}

				if (e.data.log) console.log(...e.data.log);

				_.each(e.data, (value, key) => {

					Broadcast.call(`IFrame Data:${key}`, [value, e.data]);

				});

			}

		});

	},

	setVersionSetting(versionSetting) {

		if (!this.SettingsByVersionByCodename[versionSetting["version_id"]]) this.SettingsByVersionByCodename[versionSetting["version_id"]] = {};

		this.SettingsByVersionByCodename[versionSetting["version_id"]][versionSetting["codename"]] = versionSetting;

	},

	unsetVersionSetting(versionId, settingCodename) {

		if (this.SettingsByVersionByCodename[versionId]) delete this.SettingsByVersionByCodename[versionId][settingCodename];

	},

	setVersionSettingOriginal(versionSettingOriginal) {

		if (!this.SettingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]]) this.SettingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]] = {};

		this.SettingsOriginalByVersionByCodename[versionSettingOriginal["version_id"]][versionSettingOriginal["codename"]] = versionSettingOriginal;

	},

	getVersionSettings(version, forThePlayable = false, customOnly = false) {

		if (!version) return Monitoring.clientError(`.getVersionSettings() version not found.`);

		const project = Project.Projects[version['project_id']];
		if (!project) return Monitoring.clientError(`.getVersionSettings() project not found.`);

		let settings = {};

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = version.baseVersionId ||  version.id;

		//Соберём все codename настроек со всех источников
		let settingCodenames = [];

		if (project.type === 'playable' || project.type === 'end-card') {

			//Настройки по умолчанию записанные в БД в метаданных настроек (metadata_project_playable_settings таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.ProjectPlayableSettingsByCodename));

			//Особые настройки паблишеров записанные в БД в метаданных настроек паблишера (metadata_project_playable_settings_publisher таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.ProjectPlayableSettingsPublisherByCodename[version['publisher_id']]));

			//Кастомные настройки из json файлов настроек проекта (project_version_settings_original таблица в БД)
			settingCodenames = settingCodenames.concat(_.keys(this.SettingsOriginalByVersionByCodename[baseVersionId]));

		} else if (project.type === 'banner') {

			let templateId = project.options.templateId;
			if (version.options && version.options.templateId) templateId = version.options.templateId;

			//Настройки по умолчанию записанные в БД в метаданных общих настроек (metadata_project_banner_settings таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.ProjectBannerSettingsByCodename));

			//Особые настройки паблишеров записанные в БД в метаданных настроек паблишера (metadata_project_banner_settings_publisher таблица в БД)
			if (!customOnly) settingCodenames = settingCodenames.concat(_.keys(Metadata.ProjectBannerSettingsPublisherByCodename[project["publisher_id"]]));

			//Настройки по умолчанию записанные в БД в метаданных настроек (metadata_template_banner_settings таблица в БД)
			settingCodenames = settingCodenames.concat(_.keys(Metadata.TemplateBannerSettingsByCodename[templateId]));

		}

		//Берём только уникальные
		settingCodenames = _.uniq(settingCodenames);

		_.each(settingCodenames, settingCodename => {

			let settingProps = this.getSettingProps(settingCodename) || {};

			if (settingProps.type) {

				settings[settingCodename] = settingProps;

				settings[settingCodename]["value"] = this.getSettingValue(settingCodename);
				settings[settingCodename]["version_id"] = version.id;

				if (project.type === 'playable') settings[settingCodename]["editor"] = {} //2021.11.04 Это нужно чтобы у игр на старой версии шаблона работало автообновление

			} else {

				settings[settingCodename] = this.getSettingValue(settingCodename);

			}

		});

		if (forThePlayable) settings = _.mapValues(settings, setting => {

			let result = setting.type ? _.pick(setting, ['type', 'value', 'control', 'editor', 'version_id']) : setting;

			//2022.01.16 старый creative-template требует values в корне объекта настроек если value настройки = #random
			if (setting.options && setting.options.values) result.values = setting.options.values;

			return result;

		});

		let endCardVersion = EndCard.getEndCardVersion(project, version);

		if (endCardVersion) {

			let endCardSettings = this.getVersionSettings(endCardVersion, forThePlayable, true);

			_.each(endCardSettings, setting => {

				if (settings[setting.codename]) console.warn(`EndCard Settings conflict! Playable already have setting with codename "${setting.codename}"`);

				settings[setting.codename] = setting;

			});

		}

		return settings;

	},

	isSettingValueChanged(versionId, settingCodename) {

		return !!(this.SettingsByVersionByCodename[versionId] && this.SettingsByVersionByCodename[versionId][settingCodename]);

	},

	revertSettingValue(versionId, settingCodename) {

		Server.sendToSocket({
			RevertProjectVersionSetting: {
				versionId: versionId,
				settingCodename: settingCodename
			}
		});

	},

	isSettingExist(settingCodename) {

		if (!Publisher.SelectedPublisher || !Project.SelectedProject || !Version.SelectedVersion) return false;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = Version.SelectedVersion.baseVersionId || Version.SelectedVersion.id;

		let result = false;

		if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_project_playable_settings таблица в БД)
			if (Metadata.ProjectPlayableSettingsByCodename[settingCodename]) result = true;

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_project_playable_settings_publisher таблица в БД)
			if (Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) result = true;

			//Параметры из json файла настроек проекта (project_version_settings_original таблица в БД)
			if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) result = true;

		} else if (Project.SelectedProject.type === 'banner') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_project_banner_settings таблица в БД)
			if (Metadata.ProjectBannerSettingsByCodename[settingCodename]) result = true;

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_project_banner_settings_publisher таблица в БД)
			if (Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) result = true;

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_template_banner_settings таблица в БД)
			let templateId = Project.SelectedProject.options.templateId;
			if (Version.SelectedVersion.options && Version.SelectedVersion.options.templateId) templateId = Version.SelectedVersion.options.templateId;

			if (Metadata.TemplateBannerSettingsByCodename[templateId]?.[settingCodename]) result = true;

		}

		//Параметры записанные в БД у текущей версии проекта (изменённое в дашборде значение, project_version_settings таблица в БД) не учитываем - там только value находится

		return result;

	},

	getSettingProps(settingCodename, warnings = true) {

		if (!Publisher.SelectedPublisher || !Project.SelectedProject || !Version.SelectedVersion) return null;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = Version.SelectedVersion.baseVersionId || Version.SelectedVersion.id;

		let result = null;

		if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_project_playable_settings таблица в БД)
			if (Metadata.ProjectPlayableSettingsByCodename[settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.ProjectPlayableSettingsByCodename[settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.ProjectPlayableSettingsByCodename[settingCodename].options));

			}

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_project_playable_settings_publisher таблица в БД)
			if (Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename].options));

			}

			//Параметры из json файла настроек проекта (project_version_settings_original таблица в БД)
			if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

				result = _.extendWith(result || {}, _.pick(this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename].options));

			}

		} else if (Project.SelectedProject.type === 'banner') {

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_project_banner_settings таблица в БД)
			if (Metadata.ProjectBannerSettingsByCodename[settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.ProjectBannerSettingsByCodename[settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.ProjectBannerSettingsByCodename[settingCodename].options));

			}

			//Параметры по умолчанию записанные в БД в метаданных настроек паблишера (metadata_project_banner_settings_publisher таблица в БД)
			if (Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]) {

				result = _.extendWith(result || {}, _.pick(Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.ProjectBannerSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename].options));

			}

			let templateId = Project.SelectedProject.options.templateId;
			if (Version.SelectedVersion && Version.SelectedVersion.options && Version.SelectedVersion.options.templateId) templateId = Version.SelectedVersion.options.templateId;

			//Параметры по умолчанию записанные в БД в метаданных общих настроек (metadata_template_banner_settings таблица в БД)
			if (Metadata.TemplateBannerSettingsByCodename[templateId]?.[settingCodename]) {

				//console.log('check', Metadata.TemplateBannerSettingsByCodename[templateId]?.[settingCodename]);

				result = _.extendWith(result || {}, _.pick(Metadata.TemplateBannerSettingsByCodename[templateId][settingCodename], ["codename", "type", "title", "description", "section", "section_priority", "control"]), (objValue, srcValue) => srcValue || objValue);
				result.options = _.extend(result.options || {}, _.cloneDeep(Metadata.TemplateBannerSettingsByCodename[templateId][settingCodename].options));

			}

		}

		//Параметры записанные в БД у текущей версии проекта (изменённое в дашборде значение, project_version_settings таблица в БД) не учитываем - там только value находится

		if (!result && warnings) console.log(`Project version setting props don't found. settingCodename: ${settingCodename}`);

		return result;

	},

	//Значение настройки нужно брать через этот метод, так как она может быть записана в нескольких разных местах
	getSettingValue(settingCodename) {

		//Когда создаётся новый проект баннера и в нём ещё нет версий тут не будет Version.SelectedVersion
		if (!Version.SelectedVersion) return null;

		return this.getVersionSettingValue(Version.SelectedVersion.id, settingCodename);

	},

	//Здесь возвращаем значение настройки не для текущей версии а для любой
	getVersionSettingValue(versionId, settingCodename) {

		let version = Version.Versions[versionId];
		if (!version) return null;

		let project = Project.Projects[version['project_id']];
		if (!project) return;

		//id версии из которой была создана текущая версия (либо id текущей версии если она базовая)
		let baseVersionId = version.baseVersionId || version.id;

		let value = null;

		if (project.type === 'playable' || project.type === 'end-card') {

			//Значение записанное в БД у текущей версии проекта (изменённое в дашборде значение, project_version_settings таблица в БД)
			if (this.SettingsByVersionByCodename[version.id] && this.SettingsByVersionByCodename[version.id][settingCodename]) {

				value = this.SettingsByVersionByCodename[version.id][settingCodename]["value"];

				//Значение из json файла настроек проекта (project_version_settings_original таблица в БД)
			} else if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

				value = this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных настроек паблишера (metadata_project_playable_settings_publisher таблица в БД)
			} else if (Metadata.ProjectPlayableSettingsPublisherByCodename[version['publisher_id']] && Metadata.ProjectPlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename] && ('value' in Metadata.ProjectPlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename])) {

				value = Metadata.ProjectPlayableSettingsPublisherByCodename[version['publisher_id']][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных общих настроек (metadata_project_playable_settings таблица в БД)
			} else if (Metadata.ProjectPlayableSettingsByCodename[settingCodename]) {

				value = Metadata.ProjectPlayableSettingsByCodename[settingCodename]["value"];

				//Иначе возвращаем null - значение настройки не найдено
			} else {

				console.warn(`Project version setting value don't found. selectedProject: ${project.codename} selectedVersion: ${version.codename || version.title} settingCodename: ${settingCodename}`);

			}

		} else if (project.type === 'banner') {

			let templateId = project.options.templateId;
			if (version.options && version.options.templateId) templateId = version.options.templateId;

			//Значение записанное в БД у текущей версии проекта (изменённое в дашборде значение, project_version_settings таблица в БД)
			if (this.SettingsByVersionByCodename[version.id] && this.SettingsByVersionByCodename[version.id][settingCodename]) {

				value = this.SettingsByVersionByCodename[version.id][settingCodename]["value"];

			} else if (Metadata.TemplateBannerSettingsByCodename[templateId][settingCodename]) {

				value = Metadata.TemplateBannerSettingsByCodename[templateId][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных настроек паблишера (metadata_project_banner_settings_publisher таблица в БД)
			} else if (Metadata.ProjectBannerSettingsPublisherByCodename[version['publisher_id']] && Metadata.ProjectBannerSettingsPublisherByCodename[version['publisher_id']][settingCodename] && ('value' in Metadata.ProjectBannerSettingsPublisherByCodename[version['publisher_id']][settingCodename])) {

				value = Metadata.ProjectBannerSettingsPublisherByCodename[version['publisher_id']][settingCodename]["value"];

				//Значение по умолчанию записанное в БД в метаданных общих настроек (metadata_project_banner_settings таблица в БД)
			} else if (Metadata.ProjectBannerSettingsByCodename[settingCodename]) {

				value = Metadata.ProjectBannerSettingsByCodename[settingCodename]["value"];

				//Иначе возвращаем null - значение настройки не найдено
			} else {

				console.warn(`Project version setting value don't found. selectedProject: ${project.codename} selectedVersion: ${version.codename || version.title} settingCodename: ${settingCodename}`);

			}

		}

		//Будем всё время клонировать значение так как контролы для редактирования настроек могут изменить значение настройки-объекта
		//и эти изменения попадут во все проекты если изначальное значение было взято из метаданных
		return _.cloneDeep(value);

	},

	//Такая же функция есть на сервере - если менять здесь, то вероятно нужно менять и там
	getSettingOriginalValue(settingCodename) {

		let baseVersionId = Version.SelectedVersion.baseVersionId ||  Version.SelectedVersion.id;

		//Значение из json файла настроек проекта (project_version_settings_original таблица в БД)
		if (this.SettingsOriginalByVersionByCodename[baseVersionId] && this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]) {

			return this.SettingsOriginalByVersionByCodename[baseVersionId][settingCodename]["value"];

		//Значение по умолчанию записанное в БД в метаданных настроек паблишера (metadata_project_playable_settings_publisher таблица в БД)
		} else if (Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename] && ('value' in Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename])) {

			return Metadata.ProjectPlayableSettingsPublisherByCodename[Publisher.SelectedPublisher.id][settingCodename]["value"];

		//Значение по умолчанию записанное в БД в метаданны общих настроек (metadata_project_playable_settings таблица в БД)
		} else if (Metadata.ProjectPlayableSettingsByCodename[Publisher.SelectedPublisher.id] && Metadata.ProjectPlayableSettingsByCodename[Publisher.SelectedPublisher.id][settingCodename]) {

			return Metadata.ProjectPlayableSettingsByCodename[Publisher.SelectedPublisher.id][settingCodename]["value"];

		//Иначе возвращаем null - значение настройки не найдено
		} else {

			console.warn(`Project version setting original value don't found. settingCodename: ${settingCodename}`);

			return null;

		}

	},

	setSettingValue(settingCodename, value, splitName) {

		console.log("setSettingValue", settingCodename, value + (splitName || ''));

		this.sendDatabaseSetting(settingCodename, value, splitName);

	},

	setSettingValueSafe(settingCodename, value, splitName) {

		console.log("setSettingValueSafe", settingCodename, value);

		let settingProps = this.getSettingProps(settingCodename);

		if (settingProps?.type === 'number') value = parseFloat(value);

		if (typeof value !== 'number' || isNaN(value)) return;

		if (settingProps?.options?.unitsMultiplier) value = value * settingProps.options.unitsMultiplier;

		this.setSettingValue(settingCodename, value, splitName)

	},

	sendDatabaseSetting(settingCodename, value, splitName) {

		let versionId = Version.SelectedVersion.id;

		clearTimeout(this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`]);
		this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`] = setTimeout(() => {

			Server.sendToSocket({
				UpdateProjectVersionSetting: {
					versionId: Version.SelectedVersion.id,
					settingCodename,
					value,
					splitName
				}
			});

		}, 500);

		let setting = Settings.SettingsByVersionByCodename[Version.SelectedVersion?.id]?.[settingCodename];
		if (!setting) {
			if (!Settings.SettingsByVersionByCodename[Version.SelectedVersion.id]) Settings.SettingsByVersionByCodename[Version.SelectedVersion.id] = {};
			setting = Settings.SettingsByVersionByCodename[Version.SelectedVersion.id][settingCodename] = {};
		}

		if (splitName) {

			if (!setting.value) setting.value = {};
			setting.value[splitName] = value;

		} else {

			setting.value = value;

		}

		//clearTimeout(this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`]);
		//this.saveSettingValueTimeouts[`${versionId}-${settingCodename}`] = setTimeout(() => {

			Broadcast.call("Selected Version Setting Changed", [settingCodename, setting.value]);

		//}, 50);

	},

	setMultiSelectSettingValue(settingCodename, optionName, optionOn) {

		console.log("setMultiSelectSettingValue", optionName, optionOn);

		let settingProps = this.getSettingProps(settingCodename);

		let value = this.getSettingValue(settingCodename);

		if (!_.isArray(value)) throw new Error(`setMultiSelectSettingValue value is not an array! settingCodename: ${settingCodename}, optionName: ${optionName}, optionOn: ${optionOn}`);

		if (optionOn && !value.includes(optionName)) {

			if (value.length < settingProps.options["maximumCheckedCount"]) value.push(optionName);

		} else if (!optionOn && value.includes(optionName)) {

			if (value.length > settingProps.options["minimumCheckedCount"]) value.splice(value.indexOf(optionName), 1);

		}

		this.sendDatabaseSetting(settingCodename, value);

	},

	setCSSSettingValue(settingCodename, propertyName, propertyValue) {

		console.log("setCSSSettingValue", propertyName, propertyValue);

		if (["fontSize", "borderRadius", "height", "width", "left", "right", "top", "bottom"].includes(propertyName)) propertyValue = parseInt(propertyValue);

		let value = this.getSettingValue(settingCodename);

		if (!_.isObject(value)) throw new Error(`setCSSSettingValue value is not an object! settingCodename: ${settingCodename}, propertyName: ${propertyName}, propertyValue: ${propertyValue}`);

		value[propertyName] = propertyValue;

		this.sendDatabaseSetting(settingCodename, value);

	},

	setListSettingValue(settingCodename, propertyValue, listPosition) {

		console.log("setListSettingValue", settingCodename, propertyValue, listPosition);

		let value = this.getSettingValue(settingCodename);

		if (!_.isArray(value)) throw new Error(`setListSettingValue value is not an array! settingCodename: ${settingCodename}, propertyValue: ${propertyValue}, listPosition: ${listPosition}`);

		if (typeof listPosition === "number") {

			if (propertyValue) value[listPosition] = propertyValue;
			else value.splice(listPosition, 1);

		} else {

			if (propertyValue) value.push(propertyValue);

		}

		this.sendDatabaseSetting(settingCodename, value);

	},

	setRangeChancesSettingValue(settingCodename, settingValue, splitName, max) {

		let value = this.getSettingValue(settingCodename);

		if (!_.isObject(value)) throw new Error(`setRangeChancesSettingValue value is not an object! settingCodename: ${settingCodename}, settingValue: ${settingValue}, splitName: ${splitName}`);

		const oldValue = value[splitName];

		value[splitName] = parseInt(settingValue);

		if (value.reduce((a, b) => a + b) > max) value[splitName] = oldValue;

		this.sendDatabaseSetting(settingCodename, value);

	},

	unhideAllVersions() {

		const versionIds = Object.keys(Version.Versions);

		versionIds.forEach(id => {
			const version = Version.Versions[id];
			if (version.Tags && version.Tags['hidden']) delete version.Tags['hidden'];
		});

		Server.sendToSocket({
			UnhideAllVersions: {
				projectId: Project.SelectedProject.id,
				versionIds: versionIds
			}
		});

		Broadcast.call("Selected Version Changed");

	},

	isHiddenVersions() {

		let res = false;

		if (Version && Version.VersionsByProject && Version.VersionsByProject[Project.SelectedProject.id]) {
			const versionIds = Object.keys(Version.VersionsByProject[Project.SelectedProject.id]);

			versionIds.forEach(id => {
				const version = Version.Versions[id];
				if (version.Tags && version.Tags['hidden']) res = true;
			});
		}

		return res;

	},

	uploadToSkyKids(params) {

		Server.sendToSocket({
			SkyKidsUpload: params
		});

	},

	getCurrentVersionAssetsPath() {

		if (!Project.SelectedProject || !Version.SelectedVersion) return null;

		let assetsPath = this.getSettingValue("assets-path");
		if (assetsPath) return assetsPath;

		console.log('SetupSettings["projectsUrl"]', SetupSettings["projectsUrl"]);

		if (Project.SelectedProject.options.templatePlayableCodename) return `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables/${Project.SelectedProject.templateProps.options.gitRepositoryName}/${Project.SelectedProject.templateProps.options.gitBranchName}/`;
		else if (SetupSettings.dev) return `${location.protocol}${SetupSettings["projectsUrl"]}/${Project.SelectedProject.Folder}/`;
		else return `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === "https:" ? SetupSettings["portSSL"] : SetupSettings["port"])}/deploy/${Project.SelectedProject.codename}/`

	},

	getFrameSrc(force) {

		if (!Project.SelectedProject || !Version.SelectedVersion) return null;

		if (Project.SelectedProject.type === 'playable') return this.getFrameSrcForPlayable(force);
		else if (Project.SelectedProject.type === 'banner') return this.getFrameSrcForBanner(force);
		else if (Project.SelectedProject.type === 'end-card') return this.getFrameSrcForEndCard(force);

	},

	getFrameSrcForPlayable(force) {

		let settings = this.getVersionSettings(Version.SelectedVersion, true);

		if (force) settings["version"] = Date.now();

		settings["dashboard-preview-mode"] = true;
		settings["version-name"] = Version.SelectedVersion ? (Version.SelectedVersion["codename"] || Version.SelectedVersion["title"]) : '';
		settings["project-type"] = 'playable';
		settings["full-title"] = Project.SelectedProject.title;
		settings["project-id"] = Project.SelectedProject.id || 0;


		const assets = Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion));
		if (_.size(assets) === 0) return null; //Сомнительный код. Теоретически может быть игра без ассетов (всё на примитивах)
		settings.Assets = assets;

		//Убираем из ассетов замененные файлы шрифтов
		_.each(settings.Assets, (asset, key) => {

			if (asset.type === 'web-font' && asset.isHidden) delete settings.Assets[key];
			
		});

		settings.Localization = Localization.cleanVersionLocalization(Localization.getVersionLocalization(Version.SelectedVersion));

		let tag = '';
		let scripts = '';

		if (!settings["assets-path"]["value"]) settings["assets-path"]["value"] = this.getCurrentVersionAssetsPath();

		if (SetupSettings.dev && !Project.SelectedProject.Tags.released) {

			tag = this.TagTemplateDevelopment;

			if (Project.SelectedProject.Scripts) {

				_.each(Project.SelectedProject.Scripts["loaderLibs"], (file_path) => {
					if (file_path.charAt(0) !== " ") scripts += `\t\t<script src="${settings["assets-path"]["value"]}${file_path}"></script>\n`;
				});

				_.each(Project.SelectedProject.Scripts["loaderFiles"], (file_path) => {
					if (file_path.charAt(0) !== " ") scripts += `\t\t<script src="${settings["assets-path"]["value"]}${file_path}"></script>\n`;
				});

				_.each(Project.SelectedProject.Scripts["mainLibs"], (file_path) => {
					if (file_path.charAt(0) !== " ") scripts += `\t\t<script src="${settings["assets-path"]["value"]}${file_path}"></script>\n`;
				});

				_.each(Project.SelectedProject.Scripts["mainFiles"], (file_path) => {
					if (file_path.charAt(0) !== " ") scripts += `\t\t<script src="${settings["assets-path"]["value"]}${file_path}"></script>\n`;
				});

			}

		} else {

			tag = this.TagTemplateProduction;

		}

		let publisher = Publisher.Publishers[Project.SelectedProject["publisher_id"]];

		if (publisher.options["IncludeScripts"]) {

			_.each(publisher.options["IncludeScripts"], scriptObj => {

				//Если этот скрипт нужно подключать в релиз
				if (scriptObj["dashboard"]) {

					scripts += `\t\t<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}${scriptObj["path"]}"></script>\n`;

				}

			});

		}

		let endCardVersion = EndCard.getEndCardVersion(Project.SelectedProject, Version.SelectedVersion);

		if (endCardVersion) {

			let endCardProject = Project.Projects[endCardVersion['project_id']];

			if (endCardProject) {

				tag = tag.replace('"scripts-place-2"', `
					<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/end-cards/${endCardProject.templateProps.version}/end-card.pixi.min.js"></script>
				`);

				settings.Screens = Screen.getVersionScreens(endCardVersion);
				settings.DisplayObjects = DisplayObject.getVersionDisplayObjects(endCardVersion);
				settings.Animations = Animation.getVersionAnimations(endCardVersion);
				settings.AnimationSteps = Animation.getVersionAnimationSteps(endCardVersion);

				settings.TransitionsByCodename = Metadata.TransitionsByCodename;
				settings.TransitionStepsByTransitionCodename = Metadata.TransitionStepsByTransitionCodename;

			} else {

				tag = tag.replace('"scripts-place-2"', ``);

			}

		} else {

			tag = tag.replace('"scripts-place-2"', ``);

		}

		tag = tag.replace('loader-url', settings["assets-path"]["value"] + `${settings["game-loader-url"] || 'Builds/loader.min.js'}?v=` + settings["version"]);
		tag = tag.replace('"settings-place"', 'Settings = ' + this.getFrameSettings(settings) + ';</script>');
		tag = tag.replace('"scripts-place"', scripts);

		let blob = new Blob([tag], {type: "text/html"});

		return URL.createObjectURL(blob);

	},

	getFrameSrcForBanner() {

		let templateId = Project.SelectedProject.options.templateId;
		if (Version.SelectedVersion && Version.SelectedVersion.options.templateId) templateId = Version.SelectedVersion.options.templateId;
		let template = Metadata.Templates[templateId];

		return `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === "https:" ? SetupSettings["portSSL"] : SetupSettings["port"])}/banners/${template.codename}/index.html?v=${Date.now()}`;

	},

	getFrameSrcForEndCard(force) {

		let settings = this.getVersionSettings(Version.SelectedVersion, true);

		if (force) settings["version"] = Date.now();

		settings["dashboard-preview-mode"] = true;
		settings["disable-close-button-creation"] = true;
		settings["debug"]["value"] = !!SetupSettings.dev;
		settings["debug-logger"]["value"] = "native";
		settings["custom-close-button"]["value"] = 0;
		settings["interstitial-timeout"]["value"] = 0;
		settings["end-card"] = true;
		settings["version-name"] = Version.SelectedVersion ? (Version.SelectedVersion["codename"] || Version.SelectedVersion["title"]) : '';
		settings["project-type"] = 'end-card';
		settings["full-title"] = Project.SelectedProject.title;
		settings["project-id"] = Project.SelectedProject.id || 0;
		settings["preserve-drawing-buffer"] = true; //это нужно чтобы получать корректный скриншот канваса

		settings.Assets = Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion));
		settings.Localization = Localization.cleanVersionLocalization(Localization.getVersionLocalization(Version.SelectedVersion));
		settings.Screens = Screen.getVersionScreens(Version.SelectedVersion);
		settings.DisplayObjects = DisplayObject.getVersionDisplayObjects(Version.SelectedVersion);
		settings.Animations = Animation.getVersionAnimations(Version.SelectedVersion);
		settings.AnimationSteps = Animation.getVersionAnimationSteps(Version.SelectedVersion);

		settings.TransitionsByCodename = Metadata.TransitionsByCodename;
		settings.TransitionStepsByTransitionCodename = Metadata.TransitionStepsByTransitionCodename;

		settings["assets-path"]["value"] = `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/end-cards/${Project.SelectedProject.templateProps.version}/`;
		settings["game-code-url"] = false;
		settings["loading-overlay-styles"]["value"]["display"] = "none";
		settings["load-on"]["value"] = "none";

		let tag =
			`<!DOCTYPE html>
			<html lang="en">
				<head>
					<meta http-equiv="content-type" content="text/html; charset=utf-8">
					<meta charset="UTF-8">
					<script>
						Settings = ${this.getFrameSettings(settings)};
					</script>
					<script src="${settings["assets-path"]["value"]}end-card.pixi.test-project.min.js?v=${settings["version"]}"></script>
					<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-dashboard-integration-script.js?v=${settings["version"]}"></script>
					<script src="${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/playables-release-integration-script.js?v=${settings["version"]}"></script>
					<script src="${settings["assets-path"]["value"]}end-card.pixi.min.js?v=${settings["version"]}"></script>
				</head>
				<body></body>
			</html>`;

		let blob = new Blob([tag], {type: "text/html"});

		return URL.createObjectURL(blob);

	},

	getFrameSettings(settings) {

		return JSON.stringify(settings, null, 4);

	},

	isReleaseAvailable(release, multipleAllowed, scope) {

		if (typeof release === 'string') release = Metadata.ReleasesByCodename[release];

		if (!release) return false;

		if (!release['enabled']) return false;

		if (!release.options['scope'].includes(scope)) return false;

		if (multipleAllowed && scope === 'download' && release.codename === 'sky-kids') return false;

		if (release.codename in (Publisher.SelectedPublisher.options['Releases'] || {})) return Publisher.SelectedPublisher.options['Releases'][release.codename];

		return release.options["enabledByDefault"];

	},

	convertHex(value) {

		if (value.length === 4 && value.indexOf('#') === 0) {

			value = value.slice(1);

			value = '#' + value.split('').map(function (hex) {
				return hex + hex;
			}).join('');

		}

		return value;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Settings) Settings = window.Settings;
else window.Settings = Settings;

export { Settings }

